import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "./ui/dialog";
import { Input } from "./ui/input";
import { getAttribution, trackLead } from "../lib/tracking";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = "h-12 rounded-none border-0 border-b border-neutral-300 bg-transparent px-0 text-base font-light shadow-none focus-visible:border-neutral-950 focus-visible:ring-0";
const lbl = "text-[11px] uppercase tracking-[0.22em] text-neutral-600";
const EMPTY = { name: "", email: "", phone: "" };

const Done = ({ name, tier }) => (
  <div className="py-4 text-center" data-testid="membership-join-thanks">
    <p className="kicker">Request received</p>
    <p className="font-display mt-3 text-3xl font-light text-neutral-950">Thank you, {name.split(" ")[0]}.</p>
    <p className="mt-4 text-sm font-light leading-relaxed text-neutral-600">We'll be in touch shortly to set up your {tier} membership. Questions? Call or text <a href={`tel:${PHONE_TEL}`} className="underline">{PHONE_DISPLAY}</a>.</p>
  </div>
);

// Join request for a membership tier; arrives in the owner's inbox as a lead.
export const MembershipJoin = ({ tier, onClose }) => {
  const [f, setF] = useState(EMPTY);
  const [sending, setSending] = useState(false);
  const [doneName, setDoneName] = useState("");
  const label = tier ? `${tier.name} — ${tier.price}${tier.period ? ` ${tier.period}` : ""}` : "";
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const close = () => { setF(EMPTY); setDoneName(""); onClose(); };
  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const attr = getAttribution();
      await axios.post(`${API}/leads`, { ...f, ...attr, treatment: `${tier.name} Membership`, membership_interest: label, page: "memberships", source: attr.utm_source || "website" });
      trackLead({ content_name: `${tier.name} Membership`, content_category: "memberships" });
      setDoneName(f.name);
    } catch {
      toast.error("We couldn't send your details. Please check them and try again.");
    } finally {
      setSending(false);
    }
  };
  return (
    <Dialog open={!!tier} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto rounded-none sm:max-w-md" data-testid="membership-join-dialog">
        <DialogTitle className="font-display text-3xl font-light">Join {tier?.name}</DialogTitle>
        <DialogDescription className="text-xs uppercase tracking-[0.2em] text-neutral-700" data-testid="membership-join-tier">{label}</DialogDescription>
        {doneName ? <Done name={doneName} tier={tier.name} /> : (
          <form onSubmit={submit} className="mt-2 space-y-6" data-testid="membership-join-form">
            <label className="block"><span className={lbl}>Full Name</span><Input required autoComplete="name" value={f.name} onChange={set("name")} className={field} data-testid="membership-join-name" /></label>
            <label className="block"><span className={lbl}>Email</span><Input required type="email" autoComplete="email" value={f.email} onChange={set("email")} className={field} data-testid="membership-join-email" /></label>
            <label className="block"><span className={lbl}>Phone Number</span><Input required type="tel" inputMode="tel" autoComplete="tel" placeholder="(602) 555-0123" value={f.phone} onChange={set("phone")} className={field} data-testid="membership-join-phone" /></label>
            <button type="submit" disabled={sending} className="btn-ink w-full disabled:opacity-60" data-testid="membership-join-submit">{sending ? "Sending…" : "Request to Join"}</button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
